'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  horizontal: 'horizontal',
  vertical: 'vertical',
  diagonal: 'diagonal'
};